import styled, {css} from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget/jackpot-widget.component";
import {IJackpotBetWidgetBgBoxProps} from "./jackpot-bet-widget-bg.box";

export const JackpotBetWidgetBgDefaultBox = styled.div<IJackpotBetWidgetBgBoxProps>`
  
  height: 35rem;

  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    background-size: 220%;
  }
  
  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    height: 50vh;
    background-size: 210%;
  }
  
  background-image:
          url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_circle_svg.toString()}),
          linear-gradient(175.08deg, #9747FF 3.9%, #22004D 95.98%);
  background-size: 190%;
  background-repeat: no-repeat, no-repeat;
  background-position-y: 70%;
  background-position-x: 48%;

  background-blend-mode: hard-light;
  
  box-shadow: 0px -1px 24px 8px #FF77F133 inset, 0px 0px 4px 0px #83FF00BF inset, 0px 16px 48px 0px #00000038;
  border-radius: 10px;

  border: 1px solid #6D6D6D;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE && css`
        flex-direction: row;
        align-items: center;
    `}
`;
